import type { IconData } from '@stacksjs/iconify-core'

export const caretBottom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256.286 408.357L16.333 138.548V104H496v36.45ZM56.892 136l199.466 224.287L457.042 136Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default caretBottom
